
export const isLoadingAgreements = (state) => {
    return state.agreements.loading;
}

export const getAgreement = (state) => {
    let latest_version = 0;
    let latest_agreement = state.agreements.agreements[0];
    state.agreements.agreements.forEach(agreement => {
        if (parseInt(agreement.version) > latest_version) {
            latest_agreement = agreement;
        }
    })
    return latest_agreement ? latest_agreement[`agreement_${state.i18n.locale}`] : undefined;
}
